import React from "react";
import { Layout } from "../layout/Layout.js";
import { getPostComments } from "./commentsApi.js";
import { PostComments } from "../../model/comments/PostComments.js";
import { Column } from "../../../packages/ui/table/quick/Column.js";
import { formatUnixTimestampDate } from "../../../packages/date/dateFunctions.js";
import { Link } from "../../../packages/router/Link.js";
import { FixedTable } from "../../../packages/ui/table/quick/FixedTable.js";
import { useLoadEffect } from "../../../react/load/useLoadEffect.js";

/**
 * Renders list of posts with comments stats.
 */
export const PostsPage = () => {
  const result = useLoadEffect(`comments`, getPostComments);

  const columns: Column<PostComments>[] = [
    {
      span: 4,
      title: "Pealkiri",
      render: (row) => (
        <a href={`https://rlaanemets.com/${row.slug}`} target="_blank" rel="noreferrer">
          {row.title}
        </a>
      )
    },
    {
      span: 2,
      title: "Viimane kommentaar",
      render: (row) => formatUnixTimestampDate(row.lastCommentDate)
    },
    {
      span: 2,
      title: "Kommentaaride arv",
      render: (row) => <Link to={`/comments/${row.postId}`}>{row.commentCount}</Link>
    }
  ];

  return (
    <Layout title="Blogi kommentaarid" containerWidth="fixed-wide-min">
      <h2>Blogi kommentaarid</h2>
      {result.state === "success" && <FixedTable columns={columns} rows={result.data} fontSize="tiny" />}
    </Layout>
  );
};
